import {
  createDateRangeFilter,
  dateFilter,
  filter,
  FilterState,
  stringFilter,
} from '@softapps/core/filter';
import { addMonths, IsoDate, Range, startOfMonth, toIsoDate } from '@softline/core';
import { translator } from '@softline/ui-core';
import { DeliveryNoteQueryRow, DeliveryNoteStatus } from './delivery-note-query-row';
import { statusLabel } from '../helper/status-label.function';

export const DELIVERY_NOTE_DATE_FIELD = 'delivery_note.document_date' as const;

/** First day of the month three months back until today. */
export function defaultDeliveryNotePeriod(today: IsoDate = toIsoDate(new Date())): Range<IsoDate> {
  return { from: startOfMonth(addMonths(today, -3)), to: today };
}

export const deliveryNoteCorrectionFilter = (): FilterState<DeliveryNoteQueryRow> =>
  filter<DeliveryNoteQueryRow>({
    key: 'wws-delivery-note-correction',
    initialValue: createDateRangeFilter<DeliveryNoteQueryRow>(
      DELIVERY_NOTE_DATE_FIELD,
      defaultDeliveryNotePeriod()
    ),
    factory: (ref) => {
      const t = translator();
      dateFilter(ref, {
        field: DELIVERY_NOTE_DATE_FIELD,
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.DOCUMENT_DATE'),
        icon: 'fa-regular fa-calendar-range',
        defaultOperator: 'between',
        allowedOperators: ['between'],
      });
      stringFilter(ref, {
        field: 'delivery_note.customer_name',
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.CUSTOMER'),
        icon: 'fa-regular fa-user',
        defaultOperator: 'in',
        allowedOperators: ['in'],
      });
      stringFilter(ref, {
        field: 'sales_representative.name',
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.SALES_REPRESENTATIVE'),
        icon: 'fa-regular fa-user-tie',
        defaultOperator: 'in',
        allowedOperators: ['in'],
      });
      stringFilter(ref, {
        field: 'delivery_note.status' as never,
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.STATUS'),
        icon: 'fa-regular fa-circle-half-stroke',
        defaultOperator: 'in',
        allowedOperators: ['in'],
        formatter: (status) => statusLabel(status as unknown as DeliveryNoteStatus | string),
      });
      stringFilter(ref, {
        field: 'warehouse.name',
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.WAREHOUSE'),
        icon: 'fa-regular fa-warehouse',
        defaultOperator: 'in',
        allowedOperators: ['in'],
      });
      stringFilter(ref, {
        field: 'distribution_type_language.name',
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.DISTRIBUTION_TYPE'),
        icon: 'fa-regular fa-truck',
        defaultOperator: 'in',
        allowedOperators: ['in'],
      });
      stringFilter(ref, {
        field: 'delivery_note.construction_site' as never,
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.CONSTRUCTION_SITE'),
        icon: 'fa-regular fa-location-dot',
        defaultOperator: 'in',
        allowedOperators: ['in'],
      });
      stringFilter(ref, {
        field: 'project.name' as never,
        title: t('#WWS_DELIVERY_NOTE_CORRECTION.FILTER.PROJECT'),
        icon: 'fa-regular fa-diagram-project',
        defaultOperator: 'in',
        allowedOperators: ['in'],
      });
    },
  });
